import { NotifyService } from "./../services/notify-service";
import { EntityService } from "./../services/entity-service";
import * as Models from "../ts/rlAdmin.models";

export interface IEntitiesSelectedEvent {
    validEntityIdsAndTitles: Models.IEntityIdAndTitle[];
}

interface IEntityValidationSelectorBindings {
    parentCharTypeId: number;
    parentTemplateId: number;
    childCharTypeId: number;
    parentRecordId: number;
    onEntitiesSelected: (IEntitiesSelectedEvent) => void;
}

export class EntityValidationSelectorComponentController implements IEntityValidationSelectorBindings {

    public bulkError: boolean = false;
    public selectedRecIDTitlePairs: any[];
    public selectedRecords: any[];
    public selected: {};
    public isValidated: boolean;
    public inValidRecIDsOrTitles: string;
    public rawBulkIds: string;
    public validateBy: number = 0;
    public validCnt: number;
    public inValidCnt: number;
    public total: number;
    public parentCharTypeId: number;
    public parentTemplateId: number;
    public childCharTypeId: number;
    public parentRecordId: number;
    public onEntitiesSelected: (IEntitiesSelectedEvent) => void;
    constructor(
        private readonly entityService: EntityService,
        private readonly notifyService: NotifyService,
    ) {
        "ngInject";
     }
     public static $inject = ["entityService", "notifyService"];

     public validateBulkIds(): void {
        this.reset();

        if (!this.rawBulkIds) {
            return;
        }
        let bulkIds = this.getBulkIds();

        if (!bulkIds || bulkIds.length === 0) {
            return;
        }
        this.validateRecIdsOrTitlesForRelationship();
     }

    private validateRecIdsOrTitlesForRelationship = (): void => {
        let isRecIDsOrTitles: boolean = false;
        if (this.validateBy == 0) {
            isRecIDsOrTitles = true;
        }
        this.entityService.validateRecIDsOrTitlesForRelationship(this.parentCharTypeId, this.parentTemplateId, this.childCharTypeId, isRecIDsOrTitles, this.rawBulkIds, this.parentRecordId)
                    .then((result) => {
                        var validatedRecIDSorTitles: Models.IValidateRecIDsOrTitlesResponse[] = [];
                        let validEntityIds = [];
                        let validEntityTitles = [];
                        let validEntityIdsAndTitles = [];
                        if (result.success) {
                            this.isValidated = true;
                            _.forEach(result.data, (r: Models.IValidateRecIDsOrTitlesResponse) => {
                                validatedRecIDSorTitles.push(r);
                                if (r.isValid) {
                                    this.validCnt++;
                                    var selectedRecIDTitlePair: Models.IKeyValuePair<number, string> = {
                                        key: r.recID,
                                        value: r.title
                                    };
                                    this.selectedRecIDTitlePairs.push(selectedRecIDTitlePair);
                                    validEntityIds.push(r.entityId);
                                    validEntityTitles.push(r.title);
                                    validEntityIdsAndTitles.push({entityId: r.entityId, title: r.title});
                                } else {
                                    this.inValidCnt++;

                                    if (isRecIDsOrTitles) {
                                        if (this.inValidRecIDsOrTitles != "") {
                                            this.inValidRecIDsOrTitles = this.inValidRecIDsOrTitles + "\n" + r.recID.toString();
                                        } else {
                                            this.inValidRecIDsOrTitles = r.recID.toString();
                                        }
                                    } else {
                                        if (this.inValidRecIDsOrTitles != "") {
                                            this.inValidRecIDsOrTitles = this.inValidRecIDsOrTitles + "\n" + r.title;
                                        } else {
                                            this.inValidRecIDsOrTitles = r.title;
                                        }

                                    }
                                }
                                this.total = result.data.length;
                            });
                            this.onEntitiesSelected({
                                $event: {
                                    validEntities: this.selectedRecIDTitlePairs,
                                    validEntityIdsAndTitles: validEntityIdsAndTitles
                                }
                            });
                        } else {
                            this.bulkError = true;
                        }
                    })
                    .finally(() => {
                        this.notifyService.endProgress();
                    });
    }

    private getBulkIds() {
        return this.rawBulkIds.split(/\r\n|\r|\n/g);
    }

    private reset() {
        this.bulkError = false;
        this.selectedRecIDTitlePairs = [];
        this.selectedRecords = [];
        this.selected = {};
        this.isValidated = false;
        this.inValidRecIDsOrTitles = "";
        this.validCnt = 0;
        this.inValidCnt = 0;
        this.total = 0;
    }
}

export class RLEntityValidationSelector implements angular.IComponentOptions {
    public bindings: any = {
        parentCharTypeId: "<",
        parentTemplateId: "<",
        childCharTypeId: "<",
        parentRecordId: "<",
        onEntitiesSelected: "&",
    };
    public controller: any = EntityValidationSelectorComponentController;
    public controllerAs: string = "searchVM";
    public transclude: boolean = false;
    public template: string = require("./entity-validation-selector.html");
}